import React from 'react';
import { Step } from 'react-joyride';
import BaseTour from './BaseTour';
import { useTranslation } from 'react-i18next';

interface SubscriptionTrackerTourProps {
    isRunning: boolean;
    onComplete: () => void;
}

const SubscriptionTrackerTour: React.FC<SubscriptionTrackerTourProps> = ({ isRunning, onComplete }) => {
    const { t } = useTranslation();
    
    const steps: Step[] = [
        {
            target: 'body',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.subscription_tracker.welcome.title')}
                    </h3>
                    <p>{t('app_tour.subscription_tracker.welcome.description')}</p>
                </div>
            ),
            placement: 'center',
            disableBeacon: true,
        },
        {
            target: '[data-tour="add-subscription-button"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.subscription_tracker.add_subscription.title')}
                    </h3>
                    <p>{t('app_tour.subscription_tracker.add_subscription.description')}</p>
                </div>
            ),
            placement: 'bottom',
            spotlightClicks: false,
        },
        {
            target: '[data-tour="stats-overview"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.subscription_tracker.stats_overview.title')}
                    </h3>
                    <p>{t('app_tour.subscription_tracker.stats_overview.description')}</p>
                </div>
            ),
            placement: 'bottom',
        },
        {
            target: '[data-tour="upcoming-payments"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.subscription_tracker.upcoming_payments.title')}
                    </h3>
                    <p>{t('app_tour.subscription_tracker.upcoming_payments.description')}</p>
                </div>
            ),
            placement: 'bottom',
        },
        {
            target: '[data-tour="manage-subscriptions"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.subscription_tracker.manage_subscriptions.title')}
                    </h3>
                    <p>{t('app_tour.subscription_tracker.manage_subscriptions.description')}</p>
                </div>
            ),
            placement: 'top',
        },
        {
            target: '#categoryFilter',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.subscription_tracker.search_filter_tools.title')}
                    </h3>
                    <p>{t('app_tour.subscription_tracker.search_filter_tools.description')}</p>
                </div>
            ),
            placement: 'bottom',
        },
        {
            target: '[data-tour="recent-subscriptions"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.subscription_tracker.recent_activity.title')}
                    </h3>
                    <p>{t('app_tour.subscription_tracker.recent_activity.description')}</p>
                </div>
            ),
            placement: 'left',
        },
        {
            target: '[data-tour="notification-settings"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.subscription_tracker.payment_reminders.title')}
                    </h3>
                    <p>{t('app_tour.subscription_tracker.payment_reminders.description')}</p>
                </div>
            ),
            placement: 'left',
        },
        {
            target: '#subscriptionSelect',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.subscription_tracker.select_subscriptions.title')}
                    </h3>
                    <p>{t('app_tour.subscription_tracker.select_subscriptions.description')}</p>
                </div>
            ),
            placement: 'top',
        },
        {
            target: '[data-tour="analytics-charts"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.subscription_tracker.analytics_insights.title')}
                    </h3>
                    <p>{t('app_tour.subscription_tracker.analytics_insights.description')}</p>
                </div>
            ),
            placement: 'top',
        },
    ];


    return <BaseTour isRunning={isRunning} onComplete={onComplete} tourId="subscription-tracker" steps={steps} navigateTo="/dashboard/tools/subscription-tracker" />;
};

export default SubscriptionTrackerTour;
